import Navigation from "./Navigation";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const Policy = () => {
  return (
    <div className="page-background">
      <Navigation />
      <Container className="p-3">
        <Card className="mb-3">
          <Card.Body>
            <Card.Title className="d-flex justify-content-between align-items-start">
              AGB, Datenschutz, Impressum
            </Card.Title>
            <Card.Text className="mt-4">
              <b>AGB</b>
              <p>
                <ol>
                  <li>
                    <p>
                      Geltungsbereich
                      <br />
                      Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für
                      alle Leistungen und Produkte, insbesondere elektronische
                      Gutscheine, die in der Applikation &quot;Buono&quot;,
                      entwickelt und betrieben von Neoos GmbH, angeboten werden.
                    </p>
                  </li>
                  <li>
                    <p>
                      Nutzung der Gutscheine <br />
                      Elektronische Gutscheine sind ausschliesslich für den
                      angegebenen Zweck verwendbar. Eine Barauszahlung,
                      Rückerstattung oder ein Umtausch ist ausgeschlossen.
                    </p>
                  </li>
                  <li>
                    <p>
                      Haftungsausschluss <br />
                      Jegliche Haftung für Schäden, die aus der Nutzung oder
                      Unbrauchbarkeit der elektronischen Gutscheine entstehen,
                      wird im gesetzlich zulässigen Umfang ausgeschlossen. Dies
                      gilt insbesondere für technische Probleme, fehlerhafte
                      Übertragungen oder Missbrauch durch Dritte.
                    </p>
                  </li>
                  <li>
                    <p>
                      Garantieausschluss <br />
                      Wir übernehmen keine Garantie für die Verfügbarkeit,
                      Funktionalität oder Einlösbarkeit der elektronischen
                      Gutscheine.
                    </p>
                  </li>
                  <li>
                    <p>
                      Änderungen der Applikation <br />
                      Wir behalten uns sich die Rechte vor, jederzeit ohne
                      vorgängige Ankündigung, Änderungen an dieser Applikation
                      vorzunehmen.
                    </p>
                  </li>
                  <li>
                    <p>
                      Links <br />
                      Diese Applikation enthält Links (Verweise) zu weiteren
                      Webseiten. Wir haben keinerlei Einfluss auf deren Design
                      oder Inhalt und übernehmen deshalb auch keinerlei
                      Verantwortung. Insbesondere wird jede Haftung für den
                      Inhalt ausdrücklich abgelehnt, sei es, dass dieser
                      rechtswidrig, unsittlich oder auch nur schon nicht
                      altersgemäss ist. Besuchende einer solchen Webseite, auf
                      die innerhalb dieser Applikation gelinkt wird, tragen die
                      Verantwortung für deren Besuch vollumfänglich selbst.
                    </p>
                  </li>
                  <li>
                    <p>
                      Rechtswahl und Gerichtsstand <br />
                      Diese AGB unterliegen ausschliesslich dem Schweizer Recht.
                      Der Gerichtsstand ist Zürich.
                    </p>
                  </li>
                  <li>
                    <p>
                      Änderungen der AGB <br />
                      Wir behalten uns das Recht vor, diese AGB jederzeit zu
                      ändern. Änderungen werden auf der Webseite veröffentlicht
                      und treten mit der Veröffentlichung in Kraft.
                    </p>
                  </li>
                </ol>
              </p>
              <b>Datenschutz</b>
              <p>
                Wir behandeln Ihre personenbezogenen Daten vertraulich und
                entsprechend der gesetzlichen Datenschutzvorschriften sowie
                dieser Datenschutzerklärung. Die Nutzung dieser Applikation ist
                ohne Angabe personenbezogener Daten möglich. Wir weisen darauf
                hin, dass die Datenübertragung im Internet (z.B. bei der
                Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
                lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
                nicht möglich.
              </p>
              <b>Impressum</b>
              <p>
                Neoos GmbH
                <br />
                Merkurstrasse 45
                <br />
                8032 Zürich
              </p>
            </Card.Text>
            <Button size="sm" variant="outline-secondary" as={Link} to="/">
              Zur Applikation
            </Button>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Policy;
